import { render } from "./SendEmail.vue?vue&type=template&id=0f342e4e&scoped=true"
import script from "./SendEmail.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SendEmail.vue?vue&type=script&charset=utf-8&lang=js"

import "./SendEmail.vue?vue&type=style&index=0&id=0f342e4e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f342e4e"]])

export default __exports__